import { useDarkModeFixed } from './hook-use-dark-mode';

export const useTheme = (dark = false) => {
  const { isDarkMode, toggle } = useDarkModeFixed({
    defaultValue: dark,
  });

  return { toggle, theme: isDarkMode ? 'dark' : 'light' };
};
